/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)

import '../styles/application.css'
import ReactOnRails from 'react-on-rails';

// Category components
import CategoriesApp from '../bundles/Categories/components/CategoriesApp';
import SubcategoryDetails from '../bundles/Subcategories/components/SubcategoryDetails';

// Common components
import Header from '../bundles/Common/components/Header';
import Footer from '../bundles/Common/components/Footer';
import WhatsAppButton from '../bundles/Common/components/WhatsAppButton';
import ContactSection from '../bundles/Common/components/ContactSection';

// Admin components
import AdminDashboard from '../bundles/Admin/components/AdminDashboard';
import ProductModelManager from '../bundles/Admin/components/ProductModelManager';
import CategoryEditor from '../bundles/Admin/components/CategoryEditor';
import HeroImagesManager from '../bundles/Admin/components/HeroImagesManager';

// Debug registration
console.log("Registering components:", {
  CategoriesApp, SubcategoryDetails,
  Header, Footer, WhatsAppButton, ContactSection,
  AdminDashboard, ProductModelManager, CategoryEditor, HeroImagesManager
});

// Debug react-on-rails
console.log("ReactOnRails:", ReactOnRails);

// This is how react_on_rails can see the components in the browser.
ReactOnRails.register({
  // Category components
  CategoriesApp,
  SubcategoryDetails,

  // Common components
  Header,
  Footer,
  WhatsAppButton,
  ContactSection,

  // Admin components
  AdminDashboard,
  ProductModelManager,
  CategoryEditor,
  HeroImagesManager
});

// Debug registration completion
console.log("Components registered successfully");